export default function initSwitcher(trigger, $button, $content) {

    // TODO : review this, this is not safe
    function getFirstClass($target) {
        return $target && $target.attr("class") ? $target.attr("class").split(" ")[0] : $target;
    }

    const buttonClass = getFirstClass($button),
        activeButtonClass = buttonClass + "--active",
        triggerAttr = "[" + trigger + "]";

    $(triggerAttr).click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        $(triggerAttr).removeClass(activeButtonClass);
        $(e.target).addClass(activeButtonClass);

        const clickedId = $(e.target).attr(trigger);
        const $clicked = $("#" + clickedId);

        $content.removeClass("categories--open");
        $clicked.addClass("categories--open");

        return false;
    });

}



// WEBPACK FOOTER //
// ./js/navbar/mobile/NavbarSwitcher.js